'use client';
import { motion } from 'framer-motion';
import { opacity, slideLeft, mountAnim } from '../anim';
import styles from './style.module.scss';
import Link from './link'
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faCodepen, faHackerrank, faDribbble, faYoutube } from '@fortawesome/free-brands-svg-icons';


interface LinkProps {
    data: MenuItem;
    index: number;
}
interface MenuItem {
    title: string;
    link: string;
    redirect_to: boolean;
    description: string[];
    images: string[];
}

const menu: MenuItem[] = [
    {
        title: "Home",
        description: ['To See Everything', 'visual arts'],
        images: ['earth.png', 'squice.png'],
        link: "/",
        redirect_to: false,
    },
    {
        title: "Portfolio",
        description: ['to see everything', 'harmony of art'],
        images: ['diamond.png', 'the-glow-eye.png'],
        link: "/portfolio",
        redirect_to: false,

    },
    {
        title: "Youtube",
        description: ['To Share Everything', 'art to share'],
        images: ['look-at-me.png', 'the-brain.png'],
        link: "https://www.youtube.com/@dawnscript",
        redirect_to: true,
    }
];
const socials = [
    { icon: faGithub, link: 'https://github.com/van-surya' },
    { icon: faCodepen, link: 'https://codepen.io/dawnscript' },
    { icon: faHackerrank, link: 'https://www.hackerrank.com/profile/van_surya' },
    { icon: faDribbble, link: 'https://dribbble.com/van_surya' },
    { icon: faYoutube, link: 'https://www.youtube.com/@dawnscript?si=n8Qqt9lp8h8m23d_' },
];

interface Props {
    closeMenu: () => void;
}

const Menu: React.FC<Props> = ({ closeMenu }) => {
    return (
        <motion.div className={styles.menu} variants={opacity} initial="initial" animate="enter" exit="exit">
            <div className={styles.header}>

                <motion.svg
                    variants={slideLeft}
                    {...mountAnim}
                    onClick={closeMenu}
                    width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.6759 1.77185C4.52307 0.619019 2.65466 0.619019 1.50183 1.77185C0.349 2.92468 0.349 4.79293 1.50183 5.94576L43.5338 47.9778C44.6866 49.1306 46.555 49.1306 47.7078 47.9778C48.8607 46.8249 48.8607 44.9565 47.7078 43.8037L5.6759 1.77185Z" fill="#FBF4E6" />
                    <path d="M64.3973 60.4993C63.2445 59.3464 61.3761 59.3464 60.2233 60.4993C59.0704 61.6521 59.0704 63.5205 60.2233 64.6733L102.255 106.705C103.408 107.858 105.276 107.858 106.429 106.705C107.582 105.552 107.582 103.684 106.429 102.531L64.3973 60.4993Z" fill="#FBF4E6" />
                    <path d="M64.3973 47.9841L106.429 5.9521C107.582 4.79927 107.582 2.93103 106.429 1.7782C105.276 0.625367 103.408 0.625367 102.255 1.7782L60.2233 43.81C59.0704 44.9629 59.0704 46.8313 60.2233 47.9841C61.3761 49.1369 63.2445 49.1369 64.3973 47.9841Z" fill="#FBF4E6" />
                    <path d="M43.5338 60.4993L1.50183 102.531C0.349 103.684 0.349 105.552 1.50183 106.705C2.65466 107.858 4.52307 107.858 5.6759 106.705L47.7078 64.6733C48.8607 63.5205 48.8607 61.6521 47.7078 60.4993C46.555 59.3464 44.6866 59.3464 43.5338 60.4993Z" fill="#FBF4E6" />
                </motion.svg>
            </div>

            <div className={styles.body}>
                {menu.map((el, index) => (
                    <Link data={el} index={index} key={index} />
                ))}
            </div>
            <motion.div className="mb-8 w-full opacity-0" variants={opacity} initial="initial" animate="enter" exit="exit">
                <h2 className='text-[#FBF4E5] text-2xl text-center'>Social</h2>
                <div className="flex flex-row justify-center">
                    {socials.map((social, x) => (
                        <motion.div className='' key={x}

                        >
                            <a href={social.link} className="w-[42px] h-[42px] rounded-md flex items-center justify-center text-[1.7rem] text-[#FBF4E5] hover:bg-[#FBF4E5] hover:text-smoke "
                            >
                                <FontAwesomeIcon icon={social.icon} />
                            </a>
                        </motion.div>
                    ))}
                </div>
            </motion.div>

        </motion.div>
    );
};

export default Menu;
